import {
  CollegamentoIstanzaDettaglioDTODirezione,
  CollegamentoIstanzaDettaglioDTOTipo,
  CollegamentoRichiestaDTO,
  useGetFrontAreaPubblicaRichiesteId,
  useGetFrontAreaPubblicaRichiesteIdCartelle,
  useGetFrontTipiDomandaId,
} from '@framework/api-client';
import {
  SubmissionResponsiveCard,
  TitleSubmissionRow,
  selectTranslatedInquiryType,
} from '@framework/common-web';
import { SubmissionLogic } from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { BrandedPath, useBreadcrumbItem, useIdFromUrl } from '@framework/ui';
import { Button, Flex } from 'antd';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { useCreateSubmissionAndLinks } from '../../../components/inquiries/hooks/useCreateSubmissionAndLinks';
import { PageLayout } from '../../../ui/layout/PageLayout';
import { NetworkAlertPage } from '../../errors/network-alert/NetworkAlertPage';
import { LoadingPage } from '../../loading/LoadingPage';
import { ApplicantsTableCell } from '../../submission/ApplicantsTableCell';
import { ProcedureDataView } from './components/ProcedureDataView';
import { SubmissionDataView } from './components/SubmissionDataView';
import { FolderTreeTable } from './components/folder-table/FolderTreeTable';

const TitleDescriptionSpan = styled.span`
  font-weight: 400;
`;

interface Params {
  id: string;
}

export interface IObservationPageProps extends RouteComponentProps<Params> {}

/**
 * Pagina di dettaglio di un'osservazione (richiesta pubblica)
 *
 * //TODO Controllare se è corretto e tutti i ## sono da eliminare
 */
export function ObservationPage(props: IObservationPageProps) {
  const [submissionId] = useIdFromUrl(props, 'id');
  const { t } = useTranslation();

  const { data, error, isLoading, isFetching, isError } =
    useGetFrontAreaPubblicaRichiesteId(submissionId!, {
      query: { keepPreviousData: true },
    });
  const submission = data?.richiesta;
  const observation = data;

  const applicants = SubmissionLogic.getApplicant(
    submission,
  ) as ApplicantsTableCell;

  const rawInquiry = useGetFrontTipiDomandaId(submission?.idTipoDomanda ?? '', {
    query: { enabled: true, select: selectTranslatedInquiryType },
  });
  const inquiry = rawInquiry.data;

  const foldersResult = useGetFrontAreaPubblicaRichiesteIdCartelle(
    submissionId!,
    {
      query: { keepPreviousData: true },
    },
  );

  const links: CollegamentoRichiestaDTO[] = submission
    ? [
        {
          idRichiesta: submission.id!,
          tipo: CollegamentoIstanzaDettaglioDTOTipo.OSSERVAZIONE,
          direzione: CollegamentoIstanzaDettaglioDTODirezione.USCITA,
        },
      ]
    : [];

  const { handleClick } = useCreateSubmissionAndLinks(
    inquiry?.tipoDomandaOsservante?.id,
    links,
  );

  useBreadcrumbItem({ path: '/area-pubblica', title: 'Area Pubblica' });
  useBreadcrumbItem({
    path: props.location.pathname as BrandedPath,
    title: data?.richiesta?.progressivo,
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isError || foldersResult.isError) {
    return (
      <NetworkAlertPage
        //TODO Controllare Errori NetworkAlertPage
        error={error ?? foldersResult.error}
        message={t(
          'observation.errore-durante-il-caricamento',
          'Si è verificato un errore durante il caricamento.',
        )}
      />
    );
  }

  return (
    <PageLayout>
      <SubmissionResponsiveCard
        title={
          <TitleSubmissionRow
            right={
              inquiry?.tipoDomandaOsservante &&
              observation?.osservabile && (
                <Button size="large" onClick={handleClick}>
                  {t('observation.nuova-osservazione', 'Nuova Osservazione')}
                </Button>
              )
            }
            // stateTag={
            //   <Space size="large">
            //     <TitleDescriptionSpan>
            //       {t(
            //         'observation.numero-procedimento-suffix',
            //         'Numero Procedimento:',
            //       )}{' '}
            //       <b>{observation?.numeroProcedimento ?? 'N/A'}</b>
            //     </TitleDescriptionSpan>
            //     {submission?.progressivo !==
            //       observation?.numeroProcedimento && (
            //       <TitleDescriptionSpan>
            //         {t('observation.numero-istanza-suffix', 'Numero Istanza:')}{' '}
            //         <b>{submission?.progressivo ?? 'N/A'}</b>
            //       </TitleDescriptionSpan>
            //     )}
            //   </Space>
            // }
          >
            {observation?.oggettoProcedimento ??
              submission?.oggetto ??
              `${
                submission?.titoloTipoDomanda ??
                t('observation.domanda', 'Domanda')
              } N.${submission?.progressivo}`}
          </TitleSubmissionRow>
        }
      >
        <Flex vertical gap={24}>
          <ProcedureDataView
            submission={submission}
            osservation={observation}
          />

          <SubmissionDataView submission={submission} />

          <FolderTreeTable
            data={foldersResult.data}
            loading={foldersResult.isLoading}
          />
        </Flex>
      </SubmissionResponsiveCard>
    </PageLayout>
  );
}
